var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 137,
    viewBox: "0 0 394 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_34954_398",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 394,
    height: 137
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 394,
    height: 137,
    fill: "#FF9900"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_34954_398)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 394,
    height: 137,
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "translate",
    from: "0 0",
    to: "-50 0",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 0H47L27.8333 137H1L20.1667 0Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1667 0H97L77.8333 137H51L70.1667 0Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.167 0H147L127.833 137H101L120.167 0Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.167 0H197L177.833 137H151L170.167 0Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.167 0H247L227.833 137H201L220.167 0Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.167 0H297L277.833 137H251L270.167 0Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.167 0H347L327.833 137H301L320.167 0Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.167 0H397L377.833 137H351L370.167 0Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.167 0H447L427.833 137H401L420.167 0Z",
    fill: "#3A3A3A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150.598 100.5L193.902 25.4997C195.057 23.4998 197.943 23.4998 199.098 25.4997L242.402 100.5C243.557 102.5 242.113 105 239.804 105H153.196C150.887 105 149.443 102.5 150.598 100.5Z",
    stroke: "black",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.472 100.102L193.908 25.6407C195.065 23.6562 197.933 23.6562 199.09 25.6407L242.526 100.102C243.693 102.102 242.251 104.614 239.935 104.614H153.063C150.748 104.614 149.305 102.102 150.472 100.102ZM196.5 51.3205C199.059 51.3205 201.134 53.3953 201.134 55.9547V76.8086C201.134 79.368 199.059 81.4428 196.5 81.4428C193.94 81.4428 191.865 79.368 191.865 76.8086V55.9547C191.865 53.3953 193.94 51.3205 196.5 51.3205ZM196.5 95.3451C199.059 95.3451 201.134 93.2703 201.134 90.7109C201.134 88.1515 199.059 86.0767 196.5 86.0767C193.94 86.0767 191.865 88.1515 191.865 90.7109C191.865 93.2703 193.94 95.3451 196.5 95.3451Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_34954_398)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.499 51.3206C199.059 51.3206 201.134 53.3954 201.134 55.9548V76.8087C201.134 79.3681 199.059 81.4429 196.499 81.4429C193.94 81.4429 191.865 79.3681 191.865 76.8087V55.9548C191.865 53.3954 193.94 51.3206 196.499 51.3206Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_34954_398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.134 90.7109C201.134 93.2703 199.059 95.3451 196.499 95.3451C193.94 95.3451 191.865 93.2703 191.865 90.7109C191.865 88.1515 193.94 86.0767 196.499 86.0767C199.059 86.0767 201.134 88.1515 201.134 90.7109Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.883 104.614H239.935C242.25 104.614 243.693 102.102 242.526 100.102L199.09 25.6407C198.393 24.4447 197.074 23.9695 195.883 24.2151V51.3612C196.085 51.3343 196.29 51.3205 196.499 51.3205C199.059 51.3205 201.134 53.3953 201.134 55.9547V76.8086C201.134 79.368 199.059 81.4428 196.499 81.4428C196.29 81.4428 196.085 81.429 195.883 81.4022V86.1174C196.085 86.0906 196.29 86.0767 196.499 86.0767C199.059 86.0767 201.134 88.1515 201.134 90.7109C201.134 93.2703 199.059 95.3451 196.499 95.3451C196.29 95.3451 196.085 95.3313 195.883 95.3045V104.614Z",
    fill: "#D71111"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_34954_398",
    x: 187.865,
    y: 47.3206,
    width: 17.2686,
    height: 38.1223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.395133 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_34954_398"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_34954_398",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_34954_398",
    x: 187.865,
    y: 82.0767,
    width: 17.2686,
    height: 17.2683,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.395133 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_34954_398"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_34954_398",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/noteIcon.9cba118efe87d7eef979f9be80c5dd52.svg";
export { ForwardRef as ReactComponent };